<template>
	<div>
		<form data-abide2 novalidate data-vv-scope="form1">
			<div class="center">
				<input type="hidden"
               name="type"
              value="club"
         v-validate="{required: true}" />

        <div class="name-edit">
          <label>
            <input type="text"
     v-bind:placeholder="trans('title')"
              maxlength="50"
              :required="titleRequired"
      v-bind:data-vv-as="trans('title')"
                   @blur="suggestLink"
                v-model="title"
             v-validate="{required: titleRequired}"
                 :class="{'is-invalid-input': errors.has('form1.title')}"
                   name="title" />

            <span class="form-error" :class="{'is-visible': errors.has('form1.title')}">
              {{ errors.first('form1.title') }}
            </span>
          </label>
        </div>

        <div class="box">
          <div id="club-main-pic" class="profile-main-pic" @click.self="openGallery('clear', true)">
            <div v-if="!defaultEventPhoto.match(/default_180x180/)"
                class="img" 
               :style="{'background': defaultEventPhoto}">
            </div>
            <div v-if="!defaultEventPhoto.match(/default_180x180/)"
          @click.stop="clearAvatar('clear')"
                class="close">
            </div>
            <div v-if="(defaultEventPhoto.match(/assets\/img\/toohot_/) || defaultEventPhoto.match('img\/prohibited')) && !backFlag" class="spinner-container">
              <img class="preloader"
                   src="/assets/img/preloader.svg"
                   alt="">
            </div>
          </div>
        </div>

        <PhotoGallery/>

        <div class="box description-link">
          <div class="row">
            <div class="headline">{{ trans('club_description') }}</div>
              <textarea :style="{'padding-bottom': textarea.height ? 30 + 'px' : 0}"
                       v-model="description"
            v-bind:placeholder="trans('club_description_placeholder')"
                         :rows="textarea.rows"
                           ref="textAreaDescription"
                     maxlength="500"
                         class="form-control no-swiping description"
                        @input="resizeTextArea"
                         @blur="unfocusTextArea"
                       @key.up="() => {setTimeout(resizeTextArea, 100)}"
             v-bind:data-vv-as="trans('club_description')"
                    v-validate="'required'"     
                        :class="{'is-invalid-input': errors.has('form1.description')}"
                          name="description"
                      required></textarea>
            <span class="form-error" :class="{'is-visible': errors.has('form1.description')}">
              {{ errors.first('form1.description') }}
            </span>
          </div>
        </div>

        <div class="box handle">
          <span class="handle-icon">@</span>
          <label>
            <input type="text"
                   placeholder="web address"
                   v-bind:data-vv-as="trans('handle')"
                   v-model="handle"
                   @blur="checkLink"
                   v-validate="{required: true, min: 3, max: 15, regex:/^[a-zA-Z0-9\-_.]+$/}"
                   :class="{'is-invalid-input': errors.has('form1.handle')}"
                   name="handle"
            >
            <span class="form-error" :class="{'is-visible': errors.has('form1.handle')}">
                            {{ errors.first('form1.handle') }}
                          </span>
          </label>
        </div>

        <div class="box website">
          <span class="website-icon"></span>
          <label @click="() => { this.userIsPro ? () => {} : this.requirementsAlertShow('clubs_website') }">
            <input type="text"
            placeholder="web address"
      v-bind:data-vv-as="trans('website')"
                v-model="website"
                  :class="{'is-invalid-input': errors.has('form1.website')}"
                    name="website"
              :disabled="!userIsPro"
                >
            <span class="form-error" :class="{'is-visible': errors.has('form1.website')}">
                {{ errors.first('form1.website') }}
              </span>
          </label>
        </div>


        <div class="box invitation">
          <div class="row">
            <div class="toggle_label">
              <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22.5 10H21.25V7.5C21.25 4.05 18.45 1.25 15 1.25C11.55 1.25 8.75 4.05 8.75 7.5V10H7.5C6.125 10 5 11.125 5 12.5V25C5 26.375 6.125 27.5 7.5 27.5H22.5C23.875 27.5 25 26.375 25 25V12.5C25 11.125 23.875 10 22.5 10ZM15 21.25C13.625 21.25 12.5 20.125 12.5 18.75C12.5 17.375 13.625 16.25 15 16.25C16.375 16.25 17.5 17.375 17.5 18.75C17.5 20.125 16.375 21.25 15 21.25ZM11.25 10V7.5C11.25 5.425 12.925 3.75 15 3.75C17.075 3.75 18.75 5.425 18.75 7.5V10H11.25Z" fill="#9D9D9D"/>
              </svg>
              <div class="title private-switch">
                {{ trans('clubs.invitation_only_club') }}
              </div>
            </div>
            <div class="field">
              <div class="toggle-switch" @click="onPrivateToggleClick">
                <input type="checkbox"
                          id="is_private"
                          v-model='is_private'
                          :disabled="force_private"
                          true-value="1"
                          false-value="0"
                          name="is_private" />
                <label for="is_private">
                  <span class="toggle-track"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="box hide_admin">
          <div class="row">
            <div class="toggle_label">
              <svg style="margin-left:5px;" width="22" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.14.3a1 1 0 0 1 1.41 0l18 18a1 1 0 1 1-1.41 1.4l-3.16-3.15A10.1 10.1 0 0 1 10.84 18c-2.86 0-5.19-1.26-6.92-2.7a17.73 17.73 0 0 1-3.5-4.05l-.03-.04c-.11-.19-.27-.43-.34-.76a2.16 2.16 0 0 1 0-.9c.07-.33.23-.57.35-.76l.02-.04c.6-.95 1.83-2.67 3.62-4.14l-2.9-2.9a1 1 0 0 1 0-1.42ZM7.4 7.96A3.99 3.99 0 0 0 10.84 14c.75 0 1.44-.2 2.04-.55l-1.52-1.52a2 2 0 0 1-2.45-2.45L7.4 7.97Z" fill="#9D9D9D"/>
                <path d="M14.84 9.75a4 4 0 0 0-3.75-3.74L7.64 2.55a9.68 9.68 0 0 1 3.2-.55c2.87 0 5.2 1.26 6.93 2.7a17.73 17.73 0 0 1 3.5 4.05l.02.04c.12.19.27.43.35.76.06.28.06.62 0 .9-.08.33-.23.57-.35.76l-.02.04a18.4 18.4 0 0 1-2.16 2.78l-4.27-4.28Z" fill="#9D9D9D"/>
              </svg>
              <div class="title private-switch">
                {{ trans('clubs.hide_club_admin') }}
              </div>
            </div>
            <div class="field">
              <div class="toggle-switch">
                <input type="checkbox"
                       id="hide_admin"
                       v-model='hide_admin'
                       true-value="1"
                       false-value="0"
                       name="hide_admin" />
                <label for="hide_admin">
                  <span class="toggle-track"></span>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="box location">
          <div class="row">
            <div class="title">{{ trans('location') }}</div>

            <div class="detail location notranslate" v-if="(addressShow || addressError)">
              {{ addressShow }}
              <span class="form-error" :class="{'is-visible': addressError}">
                {{ addressError }}
              </span>
            </div>
          </div>

          <div id="map-box" class="address show" :class="{'no-address': !addressShow}">
            <div class="input-wrapper notranslate">
              <label>
                <input class="form-control"
                        type="text"
                        name="address"
                :placeholder="trans('club_address')"
                :data-vv-as="trans('address')"
                    v-model="address"
                  v-validate="'required'"
                      :class="{'is-invalid-input': errors.has('form1.address')}"
                      @input="handleAddressModification"
                    required/>

                <span class="form-error" :class="{'is-visible': errors.has('form1.address')}">
                  {{ errors.first('form1.address') }}
                </span>
              </label>
            </div>
            <div class="map-box" :style="{'height': '450px'}">
              <Map :lat="lat"
                  :lng="lng"
                  :zoom="15"
                :styles="mapHeight"
            :clickable="true"
            :draggable="true"
              :options="mapOptions"
              :dragEnd="handleMapMarkerDrag"/>
            </div>
          </div>
        </div>
        
        <button class="btn publish" id="button6" type="button" @click="submit" v-if="!id">{{ trans('clubs.publish') }}</button>
        <button class="btn publish" id="button6" type="button" @click="submit" v-else>{{ trans('save') }}</button>
      </div>
		</form>
	</div>
</template>

<script>
	import _ from "lodash";
	import Map from '@buddy/views/widgets/Map.vue';
	import {mapState, mapActions} from "vuex";
	import clubsModule from '@clubs/module/store/type'
  import PhotoGallery from '@clubs/views/widgets/club/create/media/PhotoGallery.vue'

	export default {
			mixins: [
					require('@general/lib/mixin').default,
					require('@general/lib/mixin-clubs').default
			],
			props: ['vars'],
			data() {
					return {
						...this.vars,
            manualLocationSet: true,
            timer: null,
            is_private:0,
            hide_admin: 0,
            force_private: false
					}
			},
			components: {
					Map,
          PhotoGallery
			},
			computed: {
          ...mapState({
              userIsPro: 'userIsPro',
          }),
					selectedPhotosArray() {
						return this.$parent.selectedPhotosArray;
					},
          mapHeight() {
					    return '450px';
          },
          mapOptions() {
              return {
                scrollWheelZoom: false,
                dragging: true,
                touchZoom: true
              }
          },
					selectedVideosArray() {
						return this.$parent.selectedVideosArray;
					},
          leftPublicPhotosCount() {
            const maxAmount = app.maxPublicPicturesAmount;
            const publicPhotos = this.selectedPhotos;
            return (publicPhotos.length >= maxAmount) ? 0 : (maxAmount-publicPhotos.length);
          },
          titleRequired() {
            return true;
          }
			},
      watch: {
        vars: {
          deep: true,
          handler(newVal) {
            if (newVal) {
              this.is_private = + newVal.is_private;
              this.hide_admin = + newVal.hide_admin;
              this.force_private = !!newVal.force_private;
            }
          }
        },
        type(){
          if (app.isDesktop) {
            this.$parent.$parent.$refs.vueCustomScrollbar.$forceUpdate()
          }
        }
      },
      mounted() {
        this.type = 'club'

        this.is_private =  + this.vars.is_private;
        this.hide_admin =  + this.vars.hide_admin;
        this.force_private = !!this.vars.force_private;
        this.$store.dispatch('loadCurrentUserInfo');
      },
      methods: {
					...mapActions({
						setClub:  clubsModule.actions.setClub,
						saveClub: clubsModule.actions.clubs.submit
					}),

        onPrivateToggleClick(e) {
          if (this.force_private) {
            if (e) {
              e.preventDefault();
              e.stopPropagation();
            }
            this.showErrorNotification('clubs.write_to_support_to_open_club');
          }
        },

        async checkLink(){
          let checklink = await this.$store.dispatch('checkUserLink',{handle: this.handle, type:'event', id: 0});
          if(!checklink.data.success){
            this.errors.add({
              field: 'form1.handle',
              msg: 'Current link is used. You can use this: ' + checklink.data.links_suggestions.join(', ')
            });
          }
        },
        async suggestLink(){
          if(!this.errors.has('form1.title') && !this.handle){
            let link_suggestion =  this.title.replaceAll(/[^a-zA-Z0-9-._]+/g, "").substring(0, 15)
            let checklink = await this.$store.dispatch('checkUserLink',{handle: link_suggestion, type:'event', id: 0})
            if(checklink.data.success){
              this.handle = link_suggestion;
            }else{
              this.handle = checklink.data.links_suggestions[0];
            }
          }
        },
          checkDeletePhoto(photoId) {
            const filterId = this.deletedPhotos.filter((filter) => {
              return filter === photoId;
            });

            if (filterId) {
              this.removeByValue(this.deletedPhotos, photoId);
            }
          },
          removeByValue(arr) {
            let what, a = arguments, length = a.length, ax;
            while (length > 1 && arr.length) {
              what = a[--length];
              while ((ax = arr.indexOf(what)) !== -1) {
                arr.splice(ax, 1);
              }
            }
            return arr;
          },
					defaultEventBackground(data) {
						if (data) {
						  let photo = data[0];
							this.defaultEventPhoto = `url(${photo.photo_small}) center / cover`
							photo.is_default = 'yes';
							this.preview_photo = photo;
						}
					},
					async clearAvatar(slot) {
            let photo = this.preview_photo;

            app.$emit('avatar-preloader', { slot, value: true })
            //await this.makePhotoVisibleTo(photo.id, 'private')
            this.defaultEventPhoto = 'url("/assets/img/default_180x180.jpg") center / cover';
            this.preview_photo = [];
            this.deletedPhotos.push(photo.id)
            await this.$store.dispatch('loadCurrentUserInfo')
            app.$emit('avatar-preloader', { slot, value: false })
					},
          fixDescription() {
					    let v = this

					    document.getElementById('scroll-club').addClubListener('scroll', function () {
					      let container, editor;

					      v.$nextTick(() => {
                  editor = v.$refs.vueEditor;
                  container = editor.$refs.quillContainer;

                  container.childNodes[0].className += ' disable-overflow';
                })


                this.timer = setTimeout(() => {
                  container.childNodes[0].classList.remove('disable-overflow')
                }, 100)
              });
          },
					openGallery(slot, defaultImg = false) {
							app.$emit('show-photo-event-gallery', slot, defaultImg)
					},
          unfocusTextArea() {
            if (this.description === '') {
              this.resetTextAreaSize();
            }
          },
          resetTextAreaSize(){
            this.textarea.rows   = 1
            this.textarea.height = 45
          },
          resizeTextArea() {
            let rowsCount = Math.ceil((this.$refs.textAreaDescription.scrollHeight - 12 * 2) / 21)

            this.textarea.rows = rowsCount + 1 > 6 ? 6 : rowsCount

            if (!this.isMobile) {
              this.textarea.height = this.textarea.rows * 21 + 12 * 2
            } else {
              if (rowsCount === 1) this.textarea.height = null
              else if (rowsCount === 2) this.textarea.height = 59
              else if (rowsCount === 3) this.textarea.height = 80
              else if (rowsCount === 4) this.textarea.height = 101
              else if (rowsCount === 5) this.textarea.height = 122
              else if (rowsCount >= 6) this.textarea.height = 143
            }
          },
					async handleMapMarkerDrag(club) {
							let newLat, newLng;

							if (this.mapProviderIsGmap) {
								newLat = club.latLng.lat();
								newLng = club.latLng.lng();
							} else {
								newLat = club.target.getLatLng().lat;
								newLng = club.target.getLatLng().lng;
							}

							try {
								let fullInfo = await this.getAddressForLatLng(newLat, newLng, true);
								this.lat           = newLat;
								this.lng           = newLng;
								this.location_type = 'manual';
								this.address       = fullInfo.formattedAddress;
								this.locality      = fullInfo.locality;
								this.state         = fullInfo.state;
								this.country       = fullInfo.country;
								this.country_code  = fullInfo.country_code;
								this.addressError = null
							} catch(e) {
								this.addressError = e
							}
					},
					handleAddressModification: _.debounce(async function (club){
							let lat, lng;
							if (!club.target.value) {
								return;
							}

							try {
								//update map marker
                  this.addressShow = 'Location defining...';
									let fullInfo = await this.getLatLngForAddress(this.address, true);
							    this.addressShow = this.address;
									({lat, lng} = fullInfo.point);
									this.lat           = parseFloat(lat);
									this.lng           = parseFloat(lng);
									this.location_type = 'manual';
									this.locality      = fullInfo.locality;
									this.state         = fullInfo.state;
									this.country       = fullInfo.country;
									this.country_code  = fullInfo.country_code;
									let v = this
									setTimeout(function() {
										v.zoom = 15
									}, 500)
									this.addressError = null
							} catch(e) {
								this.addressError = e
							}
					}, 1000),

					async submit() {
            this.$validator.validate()
            this.checkLink();

						let club = _.pick(this, [
              'id',
							'title', 'description', 'type', 'handle',
							'location', 'locality', 'state',
							'country', 'country_code', 'address', 'lat', 'lng', 'address_type',
							'preview_photo', 'website', 'is_private', 'hide_admin'
						])

            if (this.deletedPhotos.length > 0) {
              club.deletedPhotos = this.deletedPhotos;
            }

						this.showLoadingButton('#button6')

            this.saveClub(club).then(() => {
              this.restoreLoadingButton('#button6')
            }).catch(() => {
              this.restoreLoadingButton('#button6')
            })
					},
			},
      deactivated() {
        //this code not works
        /*const data = this.$parent.defaultData();

        for (let key in data) {
          this[key] = data[key];
        }
        */
        this.$validator.pause()
        this.$nextTick(() => {
          this.$validator.errors.clear()
          this.$validator.fields.items.forEach(field => field.reset())
          this.$validator.fields.items.forEach(field => this.errors.remove(field))
          this.$validator.resume()
        })
      }
  }
</script>

<style scoped>
  .datepicker-active {
    background: linear-gradient(180deg, #00F000 0%, #00B400 100%) !important;
    color: black !important;
  }

  .no-address {
      padding-top: 20px;
  }

  .disable-overflow {
    overflow-y: hidden !important;
  }
</style>
